import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faTools, faPen } from '@fortawesome/free-solid-svg-icons';

// These library icons are available as <i class="fa fa-twitter"></i>
library.add( 
    faLinkedin, 
    faTwitter,
    faTools,
    faPen,
);

/**
 * This module initializes the fontawesome library
 */
export default class FaModule {

    static name = 'fa';

    constructor(node) {
        config.searchPseudoElements = true;
        dom.watch();
    }
}